import React, { useState } from "react";
import screen1 from "../assets/mockup/screen1.png";
import screen2 from "../assets/mockup/screen2.png";
import screen3 from "../assets/mockup/screen3.png";
import screen4 from "../assets/mockup/screen4.png";
import screen5 from "../assets/mockup/screen5.png";

const screenshots = [screen1, screen2, screen5, screen3, screen4];

export default function Screenshots() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSliderScroll = (event) => {
    const { scrollLeft, clientWidth } = event.currentTarget;
    const nextIndex = Math.round(scrollLeft / (clientWidth * 0.82));

    setActiveIndex(
      Math.max(0, Math.min(screenshots.length - 1, nextIndex))
    );
  };

  return (
    <section id="screens" style={styles.section}>
      <div className="container">
        <h2 style={styles.title}>Captures de l’application</h2>

        {/* MOBILE SLIDER */}
        <div style={styles.mobileShell} className="mobile-shell">
          <div style={styles.mobileHint}>Faites glisser pour voir les ecrans</div>
          <div
            style={styles.mobileSlider}
            className="mobile-slider-rail"
            onScroll={handleSliderScroll}
          >
            <div style={styles.sliderTrack}>
              {screenshots.map((screenshot, index) => (
                <div key={index} style={styles.mobileCard}>
                  <img
                    src={screenshot}
                    alt={`Capture GoalFit ${index + 1}`}
                    style={styles.mobileImg}
                  />
                </div>
              ))}
            </div>
          </div>
          <div style={styles.mobileDots} aria-hidden="true">
            {screenshots.map((_, index) => (
              <span
                key={index}
                style={{
                  ...styles.mobileDot,
                  ...(activeIndex === index ? styles.mobileDotActive : {}),
                }}
              />
            ))}
          </div>
        </div>

        {/* DESKTOP STATIC VIEW */}
        <div style={styles.desktopRow} className="desktop-row">
          {screenshots.map((screenshot, index) => (
            <img
              key={index}
              src={screenshot}
              alt={`Capture GoalFit ${index + 1}`}
              width={200}
              style={styles.img}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: { padding: "60px 0" },

  title: {
    textAlign: "center",
    marginBottom: 25,
    fontWeight: 800,
    fontSize: 26,
  },

  /* DESKTOP VIEW (unchanged visually) */
  desktopRow: {
    display: "flex",
    justifyContent: "center",
    gap: 20,
    flexWrap: "wrap",
  },

  img: {
    borderRadius: 20,
    boxShadow: "0 0 15px #000",
  },

  /* MOBILE SLIDER */
  mobileShell: {
    display: "none",
    marginBottom: 15,
  },

  mobileSlider: {
    display: "block",
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    paddingBottom: 20,
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
  },

  sliderTrack: {
    display: "flex",
    gap: 14,
    padding: "0 18px",
  },

  mobileCard: {
    minWidth: "82%",
    maxWidth: "82%",
    scrollSnapAlign: "center",
    background: "linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))",
    border: "1px solid rgba(126, 164, 255, 0.16)",
    borderRadius: 26,
    padding: 10,
    boxShadow: "0 22px 40px rgba(0,0,0,0.28)",
  },

  mobileImg: {
    width: "100%",
    display: "block",
    borderRadius: 18,
    boxShadow: "0 0 15px #000",
  },

  mobileHint: {
    textAlign: "center",
    color: "rgba(216, 228, 255, 0.72)",
    fontSize: 12,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 14,
  },

  mobileDots: {
    display: "flex",
    justifyContent: "center",
    gap: 8,
    marginTop: 16,
  },

  mobileDot: {
    width: 7,
    height: 7,
    borderRadius: 999,
    background: "rgba(117, 154, 241, 0.45)",
    transition: "all 0.2s ease",
  },

  mobileDotActive: {
    width: 22,
    background: "#1aa8ff",
  },
};

/* ENABLE RESPONSIVE BEHAVIOR */
const styleTag = document.createElement("style");
styleTag.innerHTML = `
  @media (max-width: 768px) {
    .desktop-row { display: none !important; }
    .mobile-shell { display: block !important; }
    .mobile-slider-rail::-webkit-scrollbar { display: none !important; }
  }

  @media (min-width: 769px) {
    .mobile-shell { display: none !important; }
  }
`;
document.head.appendChild(styleTag);
